import layout from '../LayoutFactory';
import cssUtil from 'gw-portals-util-js/CssUtil';
import menu from 'text!./menu.html';
import menuItem from 'text!./menu-item.html';
import styles from './menu-hashed.scss';

export default layout('Menu', cssUtil.hashTemplate(menu, styles), function (partial) {
    partial('Item', cssUtil.hashTemplate(menuItem, styles), ['$attrs', function ($attrs) {
        this.icon = function () {
            return $attrs.icon;
        };
    }]);
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/layouts/Menu/Menu.js
// module id = 1121
// module chunks = 0